export const buildPhoneNumberPricingItems = ({ phoneNumbers = [], t, extra = {} }) => {
  return phoneNumbers
    .filter(phone => Number(phone.quantity) > 0)
    .filter(phone => {
      const hasName = Boolean((phone.name || '').trim());
      const hasPrice = Number(phone.price || 0) !== 0;
      return hasName || hasPrice;
    })
    .map(phone => {
      const quantity = Number(phone.quantity || 0);
      const price = quantity * Number(phone.price || 0);
      const name = (phone.name || '').trim();

      return {
        label: `${name} (${quantity} ${t('calculator.numbers', 'numbers')})`,
        price,
        productType: 'phone-numbers',
        count: quantity,
        name,
        ...extra,
      };
    });
};
